import React, { useState, useEffect, useRef } from "react";
import "../../Styles/Profile.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import {
  getPeofileApi,
  updatePrifileApi,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FaCamera } from "react-icons/fa";
import { baseURL } from "../../Services/api_endpoints";

const Profile = () => {
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);
  const [profile, setProfile] = useState({
    firstName: "",
    email: "",
    primary_number: "",
   middleName:"",
   lastName:"",
    profile_pic: "",
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const imageUrl = URL.createObjectURL(file);
      setProfile((prev) => ({ ...prev, image: imageUrl }));
    }
  };

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); 
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("firstName", profile.firstName);
    formData.append("email", profile.email);
    formData.append("mobile", profile.mobile);
    formData.append("lastName", profile.lastName);
    formData.append("middleName", profile.middleName);
    if (selectedImage) {
      formData.append("profileImageFile", selectedImage);
    }

    console.log("FormData Entries:");
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await updatePrifileApi(token, formData);
      console.log("Profile Update Response:", response);

      if (response.status === 200) {
        toast.success("Profile updated successfully!");
        setProfile(response.data);
      } else {
        toast.error(
          response.data.errors?.message || "Failed to update profile."
        );
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    const fetchProfileList = async () => {
      if (!token) {
        console.error("No token provided!");
        return;
      }

      try {
        console.log("Fetching profile with token:", token);
        const response = await getPeofileApi(token);
        setProfile(response.data);
        console.log("profile:", response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchProfileList();
  }, [token]);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="profile-container">
          <div className="profile-card" style={{display:"flex",alignItems:"center",flexDirection:"column",width:"50%"}}>
            <p style={{textAlign:"center",fontSize:"23px",width:"fie-content",fontWeight:"800",borderBottom:"2px solid blue",padding:"8px"}}>Update Profile Data</p>
            <div style={{ width: "fit-content", position: "relative",border:"1px solid black",borderRadius:"50%" }}>
              <img
                src={`${baseURL}api${profile.profile_pic}`}
                alt={profile.name}
                className="profile-pic"
              />
              <FaCamera className="camera-icon" onClick={handleImageClick} style={{border:"1px solid black"}}/>
              {/* Hidden file input */}
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleImageChange}
                accept="image/*"
              />
            </div>
             <p className="info">
              <strong>First name:</strong>
              <input
                type="text"
                name="firstName"
                value={profile.firstName}
                onChange={handleChange}
                placeholder="Enter Email"
              />
            </p>
              <p className="info">
              <strong>Second name:</strong>
              <input
                type="text"
                name="middleName"
                value={profile.middleName}
                onChange={handleChange}
                placeholder="Enter Email"
              />
            </p>
              <p className="info">
              <strong>Last name:</strong>
              <input
                type="text"
                name="lastName"
                value={profile.lastName}
                onChange={handleChange}
                placeholder="Enter Email"
              />
            </p>
            <p className="info">
              <strong>Email:</strong>
              <input
                type="email"
                name="email"
                value={profile.email}
                onChange={handleChange}
                placeholder="Enter Email"
              />
            </p>
            <p className="info">
              <strong>Mobile:</strong>
              <input
                type="text"
                name="primary_number"
                value={profile.primary_number}
                readOnly
                placeholder="Enter Mobile No."
                style={{color:"#bfbfc0"}}
              />
            </p>
            
            <button className="submit-btn" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;